import { toast } from 'react-toastify'
import { AutomationModal, AutomationFormData } from './AutomationModal'
import {
  AutomationCreatePayload,
  AutomationMultipartPayload,
} from 'models/automation'
import {
  useCreateAutomation,
  useCreateAutomationMultipart,
  type CreateAutomationMutationRequest,
} from 'services/automations'
import {
  cleanAutomationActionPayload,
  cleanAutomationConditionPayload,
} from './utils'

interface CreateAutomationModalProps {
  show: boolean
  handleClose: () => void
  onAutomationCreated?: () => void
}

export function CreateAutomationModal({
  show,
  handleClose,
  onAutomationCreated,
}: CreateAutomationModalProps) {
  const createAutomationMutation = useCreateAutomation()
  const createCompanyNoteAutomation = useCreateAutomationMultipart()

  const handleSubmitSuccess = () => {
    toast.success('Automation created successfully')
    onAutomationCreated?.()
  }
  const createAutomation = async (values: AutomationFormData) => {
    // Transform form data to match database structure
    const automationData: AutomationCreatePayload = {
      name: values.name,
      description: values.description,
      is_active: true,
      // Create condition group with single condition
      condition_groups: [
        {
          logical_operator: 'OR',
          order_index: 0,
          conditions: [cleanAutomationConditionPayload(values, 0)],
        },
      ],
      // Create action using the utility function
      actions: [cleanAutomationActionPayload(values)],
    }

    if (values.action_type === 'add_company_note') {
      // Create multipart payload for company note automation
      const multipartData: AutomationMultipartPayload = {
        name: values.name,
        description: values.description,
        is_active: true,
        condition_groups: automationData.condition_groups,
        actions: automationData.actions,
        attachments: values.attachments || [],
      }
      return createCompanyNoteAutomation.mutateAsync({ data: multipartData })
    }

    return createAutomationMutation.mutateAsync({
      data: automationData as CreateAutomationMutationRequest,
    })
  }

  return (
    <AutomationModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Create"
      submitApiAction={createAutomation}
    />
  )
}
